import { jsonLoader } from "./json";
import { fontLoader } from "./font";
import { svgLoader } from "./svg";
import { htmlAudioLoader } from "./htmlaudio";
import { videoLoader } from "./video";
import { videoTransparentLoader } from "./videotransparent";
import { blobAudioLoader } from "./blobaudio";
import { imageLoader } from "./image";

class Loaders {
  #loaderMap = {};

  constructor() {
    this.#loaderMap = {
      json: jsonLoader,
      font: fontLoader,
      image: imageLoader,
      svg: svgLoader,
      htmlaudio: htmlAudioLoader,
      video: videoLoader,
      videotransparent: videoTransparentLoader,
      blobaudio: blobAudioLoader,
    };
  }

  addType(type, loader) {
    this.#loaderMap[type] = loader;
  }

  createKeyByType(type, identifier) {
    // Get the proper loader based on the type
    const typeLoader = this.#loaderMap[type];

    if (!typeLoader) {
      // TODO: ERROR: Decide which level of error is suitable here. There is no
      // known loader for the type.
      throw new Error(`No loader available for type: ${type}`);
    }

    return ["assets", typeLoader.key, identifier].join(".");
  }

  async loadByType(type, identifier, assetsPath, ignoreFolder) {
    // Get the proper loader based on the type
    const typeLoader = this.#loaderMap[type];

    if (!typeLoader) {
      // TODO: ERROR: Decide which level of error is suitable here. There is no
      // known loader for the type.
      throw new Error(`No loader available for type: ${type}`);
    }

    return typeLoader.load(assetsPath, identifier, ignoreFolder);
  }
}

const loaders = new Loaders();
export { loaders, Loaders };
